<app-confirm-dialog></app-confirm-dialog>

<!-- START row-->
<div class="row">
    <div class="col-xl-12">
        <div class="card-header statichead">
            Predict Screen
        </div>
        <!-- START card-->
        <div style="padding:10px" class="card card-default">
            <div class="card-header">
                Tenant details
            </div>

            <div class="card-body">
                <div class="form-group row">
                    <label class="col-md-9 col-form-label"></label>
                    <div class="col-md-3">
                        <div class="input-group mb-3">
                            <input class="form-control" type="text" [(ngModel)]="term" placeholder="Search..."
                                aria-label="Recipient's username" aria-describedby="basic-addon2" />
                        </div>
                    </div>
                </div>

                <div class="table-responsive">
                    <table class="table table-striped table-bordered table-hover">
                        <thead>
                            <tr>
                                <th>Sr No.</th>
                                <th>Applicant Name</th>
                                <th>Property Name</th>
                                <th>Move in date</th>
                                <th>Move Out date</th>
                                <th>Payment on Time</th>
                                <th>How many times has the rent been delayed in last quarter?</th>
                                <th>Has the applicant violated the lease in last 3 months?</th>
                                <th>Actions</th>

                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                *ngFor="let payment of reportsData ;let i=index;">
                                <td>{{((p-1)*10)+(i+1)}}</td>

                                <td>{{payment.applicantName}}</td>
                                <td>{{payment.propertyName}}</td>
                                <td>{{payment.moveInDate |date:'MM/dd/yyyy'}}</td>
                                <td>{{payment.moveOutDate |date:'MM/dd/yyyy'}}</td>
                                <td>{{payment.isPaymentOnTime}}</td>
                                <td><span *ngIf="payment.isPaymentOnTime=='no'">{{payment.rentDelayedByDays}}</span>
                                </td>
                                <td><span
                                        *ngIf="payment.isPaymentOnTime=='no'">{{payment.applicantVioletedIn3Months}}</span>
                                </td>
                                <td><span >

                                        <button type="button" class="btn btn-primary"
                                        data-toggle="modal"
                                        data-target="#preveiwDocument"
                                            (click)="edit(payment)">Details</button>

                                    </span></td>

                            </tr>
                            <label style="padding: 10px;" *ngIf="reportsData.length==0">No records found !!!</label>

                        </tbody>
                    </table>
                </div>
            </div>

        </div>
        <!-- END card-->
    </div>
</div>
<div class="modal fade" id="preveiwDocument" role="dialog">
    <div class="modal-dialog" style="max-width: 70%; height:70%;max-height: 70%;">
        <!-- Modal content-->
        <div class="modal-content">
            <div class="modal-header">
                <!-- Violations (click all that apply) -->
                <label>
                    Edit Details
                    </label>
                <button type="button" #pricingCloneModal class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">
                <div class="card"  style="
                width: auto;">
               
                <div class="card-body">
                    <form [formGroup]="tenantForm" >
                         <div>
                            <label>
                                Does the Applicant pay rent on time?
                            </label>
                            <div class="row">
        
                                <div class="radio c-radio mb-2 shiftcs">
                                    <label class="fontcs ">
                                        <input type="radio" name="radio" value="yes" name="isPaymentOnTime"
                                            formControlName="isPaymentOnTime" />
                                        <span class="fa fa-check check1"></span>
                                        Yes
                                    </label>
                                </div>
                            </div>
                            <div class="row">
        
                                <div class="radio c-radio mb-2 shiftcs">
                                    <label class="fontcs ">
                                        <input type="radio" name="radio" value="no" name="isPaymentOnTime"
                                            formControlName="isPaymentOnTime" />
                                        <span class="fa fa-check check1"></span>
                                        No
                                    </label>
                                </div>
                            </div>
        
        
                        </div>
                        <div>
        
                            <br />
                            <br />
                            <br />
                            <label>
                                Has the applicant violated the lease in last 3 months? -
                            </label>
                            <div class="row">
        
                                <div class="radio c-radio mb-2 shiftcs">
                                    <label class="fontcs ">
                                        <input type="radio" name="radio" value="yes" name="applicantVioletedIn3Months"
                                            formControlName="applicantVioletedIn3Months" />
                                        <span class="fa fa-check check1"></span>
                                        Yes
                                    </label>
                                </div>
                            </div>
                            <div class="row">
        
                                <div class="radio c-radio mb-2 shiftcs">
                                    <label class="fontcs ">
                                        <input type="radio" name="radio" value="no" name="applicantVioletedIn3Months"
                                            formControlName="applicantVioletedIn3Months" />
                                        <span class="fa fa-check check1"></span>
                                        No
                                    </label>
                                </div>
                            </div>
        
        
                        </div>
        
                        <div>
        
                            <br />
                            <br />
                            <br />
                            <label>
                                How many times has the rent been delayed in last quarter?
                            </label>
                            <div class="row">
        
                                <div class="radio c-radio mb-2 shiftcs">
                                    <label class="fontcs ">
                                        <input type="radio" name="radio" value="once" name="rentDelayedByDays"
                                            formControlName="rentDelayedByDays" />
                                        <span class="fa fa-check check1"></span>
                                        Just Once
                                    </label>
                                </div>
                            </div>
                            <div class="row">
        
                                <div class="radio c-radio mb-2 shiftcs">
                                    <label class="fontcs ">
                                        <input type="radio" name="radio" value="twice" name="rentDelayedByDays"
                                            formControlName="rentDelayedByDays" />
                                        <span class="fa fa-check check1"></span>
                                        Twice
                                    </label>
                                </div>
                            </div>
                            <div class="row">
        
                                <div class="radio c-radio mb-2 shiftcs">
                                    <label class="fontcs ">
                                        <input type="radio" name="radio" value="everyMonth" name="rentDelayedByDays"
                                            formControlName="rentDelayedByDays" />
                                        <span class="fa fa-check check1"></span>
                                        Delayed every month
                                    </label>
                                </div>
                            </div>
        
                        </div>
                        <div>
                            <br />
                            <br />
                            <br />
                            <label>
                                Violations (click all that apply)
                            </label>
                            <div class="row">
                                <div class=" mb-2 col-md-6">
                                    <div class="checkbox c-checkbox">
                                        <label>
                                            <input type="checkbox" formControlName="isRentNonPaymentAmount" />
                                            <span class="fa fa-check"></span>
                                            Non Payment of Rent
                                        </label>
                                    </div>
                                    <div class="row ">
                                        <div class=" mb-2 col-md-1">
                                        </div>
                                        <div class=" mb-2 col-md-6 flex-items">
        
                                            <span> Amount Due:
                                            </span>
        
                                            <input  type="number" min="0"
                                            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null :(event.charCode >= 48 && event.charCode <= 57)" placeholder=" "
                                                formControlName="rentNonPaymentAmount" class="form-control customTextField"
                                                id="rentNonPaymentAmount" name="rentNonPaymentAmount" maxlength="50" required>
                                        </div>
                                    </div>
                                </div>
        
                                <div class=" mb-2 col-md-6 margintop1">
                                    <div class="checkbox c-checkbox">
        
                                        <label>
                                            <input type="checkbox" formControlName="isUtilitiesNonPayment" />
                                            <span class="fa fa-check"></span>
                                            Non Payment of Utilities
                                        </label>
                                    </div>
                                    <div class="row">
                                        <div class=" mb-2 col-md-1">
                                        </div>
                                        <div class=" mb-2 col-md-6 flex-items">
        
                                            <span> Amount Due:
                                            </span>
        
                                            <input  type="number" min="0"
                                            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null :(event.charCode >= 48 && event.charCode <= 57)" placeholder=" "
                                                formControlName="utilitiesNonPaymentAmount" class="form-control customTextField"
                                                id="utilitiesNonPaymentAmount" name="utilitiesNonPaymentAmount" maxlength="50"
                                                required>
                                        </div>
                                    </div>
                                </div>
                            </div>
        
                            <div class="row margintop2">
                                <div class="mb-2 col-md-6">
                                    <div class="checkbox c-checkbox">
        
                                        <label>
                                            <input type="checkbox" formControlName="isNSFCheckCount" />
                                            <span class="fa fa-check"></span>
                                            NFs Check <br />
        
                                        </label>
                                    </div>
                                    <div class="row">
                                        <div class=" mb-2 col-md-1">
                                        </div>
                                        <div class=" mb-2 col-md-6 flex-items">
        
                                            <span> NFS Check Count:
                                            </span>
        
                                            <input  type="number" min="0"
                                            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null :(event.charCode >= 48 && event.charCode <= 57)" placeholder=" "
                                                formControlName="NSFCheckCount" class="form-control customTextField" id="NSFCheckCount"
                                                name="NSFCheckCount" maxlength="50" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-2 col-md-6">
                                    <div class="checkbox c-checkbox">
        
                                        <label>
                                            <input type="checkbox" formControlName="isEvictionUDFilled" />
                                            <span class="fa fa-check"></span>
                                            Eviction U/D Filled
                                        </label>
                                    </div>
                                    <div class="row">
                                        <div class=" mb-2 col-md-1">
                                        </div>
                                        <div class=" mb-2 col-md-6 flex-items">
        
                                            <span> Judged Amount
                                            </span>
        
                                            <input  type="number" min="0"
                                            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null :(event.charCode >= 48 && event.charCode <= 57)" placeholder=" "
                                                formControlName="judgmentAmount" class="form-control customTextField" id="judgmentAmount"
                                                name="judgmentAmount" maxlength="50" required>
                                        </div>
                                    </div>
                                </div>
        
                            </div>
        
                            <div class="row margintop2">
                                <div class=" mb-2 col-md-6">
                                    <div class="checkbox c-checkbox">
        
                                        <label>
                                            <input type="checkbox" formControlName="isLatePayments" />
                                            <span class="fa fa-check"></span>
                                            Late Payments
                                        </label>
                                    </div>
                                    <div class="row">
                                        <div class=" mb-2 col-md-1">
                                        </div>
                                        <div class=" mb-2 col-md-6 flex-items">
        
                                            <span> No. of Late Payments
                                            </span>
        
                                            <input  type="number" min="0"
                                            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null :(event.charCode >= 48 && event.charCode <= 57)" placeholder=" "
                                                formControlName="noOfLatePayments" class="form-control customTextField" id="noOfLatePayments"
                                                name="noOfLatePayments" maxlength="50" required>
                                        </div>
                                    </div>
                                </div>
                                <div class="mb-2 col-md-6 margintop1">
                                    <div class="checkbox c-checkbox">
        
                                        <label>
                                            <input type="checkbox" formControlName="isDamages" />
                                            <span class="fa fa-check"></span>
                                            Damages
        
                                        </label>
                                    </div>
        
                                    <div class="row">
                                        <div class=" mb-2 col-md-1">
                                        </div>
                                        <div class=" mb-2 col-md-6 flex-items">
        
                                            <span> Amount of Damages
                                            </span>
        
                                            <input type="number" min="0"
                                            onkeypress="return (event.charCode == 8 || event.charCode == 0) ? null :(event.charCode >= 48 && event.charCode <= 57)" placeholder=" "
                                                formControlName="damageAmount" class="form-control customTextField" id="damageAmount"
                                                name="damageAmount" maxlength="50" required>
                                        </div>
                                    </div>
                                </div>
        
                            </div>
        
                            <div class="row margintop2">
                                <div class=" mb-2 col-md-6">
                                    <div class="checkbox c-checkbox ">
        
                                        <label>
                                            <input type="checkbox" formControlName="isTurnOverToCollections" />
                                            <span class="fa fa-check"></span>
                                            Turn Over to Collection
                                        </label>
                                    </div>
        
                                    <div class="row">
                                        <div class=" mb-2 col-md-1">
                                        </div>
                                        <div class=" mb-2 col-md-6 flex-items">
        
                                            <span> Amount
                                            </span>
        
                                            <input type="number" placeholder=" "
                                                formControlName="turnOverCollectionsAmount" class="form-control customTextField"
                                                id="turnOverCollectionsAmount" name="turnOverCollectionsAmount" maxlength="50"
                                                required>
                                        </div>
                                    </div>
                                </div>
        
                                <div class="mb-2 col-md-6 margintop1">
                                    <div class="checkbox c-checkbox ">
                                        <label>
                                            <input type="checkbox" formControlName="isPaidInFull" />
                                            <span class="fa fa-check"></span>
                                            Paid in Full
                                        </label>
                                    </div>
        
                                    <div class="row">
                                        <div class=" mb-2 col-md-1">
                                        </div>
                                        <div class=" mb-2 col-md-6 flex-items">
        
                                            <span> Date Paid
                                            </span>
        
                                            <input type="date" placeholder=" "
                                                formControlName="paidDate" class="form-control" id="paidDate" name="paidDate"
                                                maxlength="50" required>
                                        </div>
                                    </div>
                                </div>
        
                            </div>
                            <div class="row">
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox">
                                    <label>
                                        <input type="checkbox" formControlName="isSkipWithoutNotice" />
                                        <span class="fa fa-check"></span>
                                        Skip Without Notice
                                    </label>
                                </div>
                                </div>
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox">
                                    <label>
                                        <input type="checkbox" formControlName="isUnauthorizedPets" />
                                        <span class="fa fa-check"></span>
                                        Unauthorized Pets
                                    </label>
                                </div>
                                </div>
                            </div>
        
        
                            <div class="row">
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox">
                                    <label>
                                        <input type="checkbox" formControlName="isAuthorizedOccupants" />
                                        <span class="fa fa-check"></span>
                                        Unauthorized Occupants
                                    </label>
                                </div>
                                </div>
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox ">
                                    <label>
                                        <input type="checkbox" formControlName="isKeysNotReturned" />
                                        <span class="fa fa-check"></span>
                                        Key not returned
                                    </label>
                                </div>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox">
                                    <label>
                                        <input type="checkbox" formControlName="isOtherLeaseViolations" />
                                        <span class="fa fa-check"></span>
                                        Other Lease Violation
                                    </label>
                                </div>
                                </div>
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox">
                                    <label>
                                        <input type="checkbox" formControlName="isTryingToLocate" />
                                        <span class="fa fa-check"></span>
                                        Try to Locate
                                    </label>
                                </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox">
        
                                    <label>
                                        <input type="checkbox" formControlName="isSection8Fraud" />
                                        <span class="fa fa-check"></span>
                                        Section 8 Fraud
                                    </label>
                                </div>
                                </div>
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox ">
                                    <label>
                                        <input type="checkbox" formControlName="isNoticeToVacate" />
                                        <span class="fa fa-check"></span>
                                        Notice to Vacate
                                    </label>
                                </div>
        </div>
                            </div>
                            <div class="row">
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox">
                                    <label>
                                        <input type="checkbox" formControlName="isOtherLeaseViolations" />
                                        <span class="fa fa-check"></span>
                                        Other Lease Violations
                                    </label>
                                </div>
                                </div>
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox">
                                    <label>
                                        <input type="checkbox" formControlName="isGoodResidentNoVoilation" />
                                        <span class="fa fa-check"></span>
                                        Good Resident No Violation
                                    </label>
                                </div>
        </div>
                            </div>
        
                            <div class="row">
                                <div class="mb-2 col-md-6 margintop1">

                                <div class="checkbox c-checkbox ">
                                    <label>
                                        <input type="checkbox" formControlName="isSection8Violations" />
                                        <span class="fa fa-check"></span>
                                        Section 8 Violation
                                    </label>
                                </div>
                                </div>
                            </div>
                            <div>
                                <button class="btn btn-primary" type="submit"
                                (click)="save()">Update</button>
                      
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            </div>
        </div>
    </div>
</div>

